import { configureStore } from "@reduxjs/toolkit";
import orderFlowReducer from "./orderFlow/orderFlowSlice";
import OrderApiReducer from "./api/OrderApi";
import SecondFlowReducer from "./api/SecondFlowApi";
import { apiV2Reducers } from "./api-v2";

export const store = configureStore({
  reducer: {
    orderFlow: orderFlowReducer,
    orderApi: OrderApiReducer,
    secondFlowApi: SecondFlowReducer,
    // Reductores de la API v2
    discounts: apiV2Reducers.discounts,
    user: apiV2Reducers.user,
    countries: apiV2Reducers.countries,
    products: apiV2Reducers.products,
    pricing: apiV2Reducers.pricing,
    contracts: apiV2Reducers.contracts,
    orders: apiV2Reducers.orders,
    customers: apiV2Reducers.customers,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;